/**
 * Esquema do app mobile (`nohraclinic-mobile/app.json` → `expo.scheme`).
 * O expo-router resolve o caminho depois do `://` como rota, então
 * `nohramobile://advisor/<id>` cai direto em `src/app/advisor/[id].tsx`.
 */
const ESQUEMA_DO_APP = 'nohramobile';

/** Marca que o site foi aberto pelo navegador in-app do celular. */
export const PARAMETRO_ORIGEM_APP = 'origem';
const VALOR_ORIGEM_APP = 'app';

/**
 * O usuário chegou aqui pelo app?
 *
 * O app abre `/discussoes/nova?origem=app` no navegador in-app (ver
 * `useAbrirSite.ts` do mobile). A query sobrevive ao handoff de sessão porque
 * `destinoSeguro()` devolve o `?next=` inteiro, query incluída.
 */
export function veioDoApp(busca: string): boolean {
  return new URLSearchParams(busca).get(PARAMETRO_ORIGEM_APP) === VALOR_ORIGEM_APP;
}

/** Deep link que devolve o usuário ao app, já na discussão. */
export function linkDeVoltaParaOApp(discussaoId: string): string {
  return `${ESQUEMA_DO_APP}://advisor/${discussaoId}`;
}

/**
 * Fecha o navegador in-app e devolve o usuário ao app, na discussão.
 *
 * Quem de fato FECHA o navegador é o app: ele escuta o deep link e chama
 * `WebBrowser.dismissBrowser()` (uma página web não tem como fechar o
 * SFSafariViewController/Custom Tabs por conta própria). Daqui só sai a
 * navegação para o esquema.
 *
 * ⚠️ Sempre acompanhado de um link visível na tela. Em SFSafariViewController
 * um redirect para esquema custom nem sempre dispara sem toque do usuário, e
 * sem o botão a pessoa ficaria olhando para uma página parada sem saber que
 * está tudo certo do outro lado.
 */
export function voltarParaOApp(discussaoId: string): void {
  window.location.href = linkDeVoltaParaOApp(discussaoId);
}
